import { text_mod_44, } from "../text/Text.js";
export const module44 = {
  title:
    "Літера є маленька",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_44,
    },
  ]
};